var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/toggle/star_24px",
    d: "M17.5 25.9143L26.5125 31.3538L24.1208 21.1018L32.0833 14.2038L21.5979 13.3143L17.5 3.64551L13.402 13.3143L2.91663 14.2038L10.8791 21.1018L8.48746 31.3538L17.5 25.9143Z",
    fill: "#14171F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.5f7553f121fd22da4d5a38e93c827608.svg";
export { ForwardRef as ReactComponent };